const marcFormV2 = document.querySelector('.marc-v2');
import './download-marc-form-v2';
import './MarcDatePicker';
if (marcFormV2) {
    import(/* webpackChunkName: "widgets/download-marc-form-v2" */ './download-marc-form-v2').then(
        ({default: DownloadMarcForm}) => {
            const downloadMarcFormElement = document.getElementById('download-marc-form');

            if (downloadMarcFormElement) {
                const booksEnabled = document.querySelector('#allPurchasedBooks, #allBooks');
                UX.DownloadMarcForm = new DownloadMarcForm(downloadMarcFormElement);

                if (booksEnabled) {
                    const isIE = UX.test.isIE();
                    if (isIE) {
                        import(
                            /* webpackChunkName: "/node_modules/litepicker-polyfills-ie11/dist" */ 'litepicker-polyfills-ie11/dist/index.js'
                        );
                    }
                    import(/* webpackChunkName: "widgets/marc-date-picker" */ './MarcDatePicker').then(
                        ({default: MarcDatePicker}) => {
                            UX.MarcDatePicker = new MarcDatePicker(downloadMarcFormElement);
                        }
                    );
                }
            }
        }
    );
}
